export default "__VITE_ASSET__BfzkqYX8__"